import { useEffect, useRef, useState } from "react";
import { PhoneIcon } from "../lib/site";

const turns = [
  { who: "Kanvia", text: "Döner Almendral, buenas noches. ¿Es para recoger o a domicilio?" },
  { who: "Cliente", text: "A domicilio. Un dürüm mixto sin cebolla y unas patatas." },
  { who: "Kanvia", text: "Dürüm mixto sin cebolla y patatas fritas. ¿Algo más?" },
  { who: "Cliente", text: "Un agua. Calle Álamos 45, tercero B." },
  { who: "Kanvia", text: "Apuntado. ¿A nombre de quién se lo dejo?" },
];

function Arc({ className }) {
  return (
    <svg className={className} viewBox="0 0 120 120" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" aria-hidden="true">
      <path d="M90 48 C102 62 102 80 90 94" />
    </svg>
  );
}

function SignalIcon() {
  return (
    <svg width="15" height="10" viewBox="0 0 15 10" fill="currentColor" aria-hidden="true">
      <rect x="0" y="6" width="2.4" height="4" rx="0.8" />
      <rect x="4" y="4" width="2.4" height="6" rx="0.8" />
      <rect x="8" y="2" width="2.4" height="8" rx="0.8" />
      <rect x="12" y="0" width="2.4" height="10" rx="0.8" />
    </svg>
  );
}

function BatteryIcon() {
  return (
    <svg width="20" height="10" viewBox="0 0 22 11" fill="none" stroke="currentColor" aria-hidden="true">
      <rect x="0.5" y="0.5" width="17" height="10" rx="2.5" opacity="0.5" />
      <rect x="2.5" y="2.5" width="11" height="6" rx="1.2" fill="currentColor" stroke="none" />
      <path d="M20 3.5v4a2 2 0 0 0 0-4Z" fill="currentColor" stroke="none" opacity="0.5" />
    </svg>
  );
}

export default function Phone() {
  const ref = useRef(null);
  const [off, setOff] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    let hidden = document.hidden;
    let visible = true;
    const update = () => setOff(hidden || !visible);
    const io = new IntersectionObserver(
      ([e]) => {
        visible = e.isIntersecting;
        update();
      },
      { threshold: 0.05 }
    );
    io.observe(el);
    const onVis = () => {
      hidden = document.hidden;
      update();
    };
    document.addEventListener("visibilitychange", onVis);
    return () => {
      io.disconnect();
      document.removeEventListener("visibilitychange", onVis);
    };
  }, []);

  return (
    <div ref={ref} className={`phone-stage${off ? " kv-off" : ""}`} data-testid="phone-animation">
      <Arc className="arc a1" />
      <Arc className="arc a2" />
      <Arc className="arc a3" />
      <div className="phone-wrap">
        <div className="phone-frame">
          <span className="ph-btn ph-btn-l1" aria-hidden="true" />
          <span className="ph-btn ph-btn-l2" aria-hidden="true" />
          <span className="ph-btn ph-btn-l3" aria-hidden="true" />
          <span className="ph-btn ph-btn-r1" aria-hidden="true" />
          <div className="phone-body">
            <span className="ph-island" aria-hidden="true" />
            <div className="ph-status font-mono">
              <span>21:34</span>
              <span className="flex items-center gap-1.5">
                <SignalIcon />
                <BatteryIcon />
              </span>
            </div>
            <div className="pv-call">
              <span className="call-avatar">
                <PhoneIcon className="h-8 w-8" />
              </span>
              <p className="font-display text-[22px] leading-tight text-crema">Número desconocido</p>
              <p className="font-mono text-[10px] uppercase tracking-[0.28em] text-salvia">
                Llamada entrante
              </p>
              <div className="call-actions">
                <span className="call-col">
                  <span className="call-btn call-decline">
                    <PhoneIcon className="h-5 w-5" />
                  </span>
                  <span className="call-label">Rechazar</span>
                </span>
                <span className="call-col">
                  <span className="call-btn call-accept">
                    <PhoneIcon className="h-5 w-5" />
                  </span>
                  <span className="call-label">Aceptar</span>
                </span>
              </div>
            </div>
            <div className="pv-convo">
              <div className="mb-5 flex items-center gap-2">
                <span className="att-dot" aria-hidden="true" />
                <span className="font-mono text-[9px] uppercase tracking-[0.28em] text-crema/70">
                  Kanvia atendiendo
                </span>
              </div>
              <div className="flex flex-col gap-4">
                {turns.map((t, i) => (
                  <div key={t.text} className={`turn t${i + 1}`}>
                    <p className="mb-1 font-mono text-[8px] uppercase tracking-[0.26em] text-salvia/80">
                      {t.who}
                    </p>
                    <p
                      className={`font-display text-[13.5px] leading-snug ${
                        t.who === "Cliente" ? "text-crema/60" : "text-crema"
                      }`}
                    >
                      {t.text}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className="ticket" data-testid="phone-ticket" aria-hidden="true">
          <div className="flex justify-between font-medium">
            <span>NUEVO PEDIDO</span>
            <span>21:34</span>
          </div>
          <div className="t-dash" />
          <div className="flex justify-between"><span>1 × Dürüm mixto</span><span>7,50</span></div>
          <div className="pl-4 opacity-60">sin cebolla</div>
          <div className="flex justify-between"><span>1 × Patatas</span><span>3,00</span></div>
          <div className="flex justify-between"><span>1 × Agua 1/2 l</span><span>1,20</span></div>
          <div className="t-dash" />
          <div className="flex justify-between font-medium"><span>TOTAL</span><span>11,70 €</span></div>
          <div className="mt-2 font-medium">DOMICILIO</div>
          <div>C/ Álamos 45, 3.º B</div>
        </div>
      </div>
    </div>
  );
}
